export const LINKS = {
  RESUME_LINK:
    "https://docs.google.com/document/d/1GUPhxA97H6ltoR0-061t2nQYOrhQuu3yWKeZH7eMQY4/edit?usp=sharing",
  GITHUB_LINK: "https://github.com/nnjustin44",
  LINKEDIN_LINK: "https://www.linkedin.com/in/justin-nguyen-00a624192/",
};

export const MOBILE_BREAKPOINT = 1100;
export const MAX_CHAT_MESSAGE_LENGTH = 500;
export const MAX_CHAT_RESPONSE_LENGTH = 4000;
export const placeHolder =
  "Hello! I am Justin's Online Native Artifical Helper. You can call me J.O.N.A.H! You can ask me anything you'd like!";
